<template>
    <base-dialog :loading="loading" :value="dialog" :width="440" :persistent="loading" :hide-close="loading"
        :title="$t('common.profilePhoto')" @input="val => { if (!val) onClickOutside() }" @close="onClickOutside">
        <div class="image-tip text-center mb-4">
            {{ $t('common.image_auto_crop') }}
        </div>
        <loading-spinner class="ma-0" height="50px" v-if="loading" />
        <div v-else class="upload-actions">
            <v-btn x-large depressed @click="takePicture" class="upload-btn">
                <v-icon color="accent">mdi-camera-outline</v-icon>
                {{ $t('common.camera') }}
            </v-btn>
            <input type="file" ref="fileUpload" style="display: none" @change="onFileSelected"
                accept="image/png, image/jpeg">
            <v-btn x-large depressed @click="$refs.fileUpload.click()" class="upload-btn">
                <v-icon color="accent">mdi-image-search-outline</v-icon>
                {{ $t('common.gallery') }}
            </v-btn>
        </div>
    </base-dialog>
</template>

<script>

import { db, storageRef } from '@/utils/Firebase'
import { mapActions } from 'vuex';

import firebase from 'firebase/app'
import "firebase/auth";

import LoadingSpinner from "@/components/common/LoadingSpinner";
import BaseDialog from '@/components/common/BaseDialog'

import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

export default {
    components: { LoadingSpinner, BaseDialog },
    data() {
        return {
            dialog: false,
            selectedFile: null,
            loading: false,
        }
    },
    computed: {
    },
    methods: {
        ...mapActions(['setCurrentUser']),
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
        },
        onClickOutside() {
            const vm = this
            if (!vm.loading) vm.hide()
        },
        async takePicture() {
            const vm = this
            let image
            try {
                image = await Camera.getPhoto({
                    quality: 100,
                    allowEditing: false,
                    resultType: CameraResultType.Uri,
                    width: 1200,
                    source: CameraSource.Camera
                });
            } catch (e) {
                return // el usuario canceló la cámara
            }

            const blob = await fetch(image.webPath).then(r => r.blob())
            await vm.uploadTask(blob)
        },
        async onFileSelected() {
            const vm = this
            const file = vm.$refs.fileUpload.files[0]
            vm.$refs.fileUpload.value = '' // permite re-seleccionar el mismo archivo
            if (!file) return;
            await vm.uploadTask(file)
        },
        async uploadTask(source) {
            const vm = this
            vm.loading = true
            try {
                vm.selectedFile = await vm.cropCenterSquareImage(source)
                const savePath = `/${vm.currentUser.uid}/avatar.jpg`
                const uploadTask = await storageRef.child(savePath).put(vm.selectedFile)
                const downloadURL = await uploadTask.ref.getDownloadURL()
                await db.collection('users').doc(vm.currentUser.uid).update({ avatar: downloadURL })
                const user = firebase.auth().currentUser
                await user.updateProfile({ photoURL: downloadURL })
                await vm.setCurrentUser(user)
                vm.hide()
                vm.toast(vm.$t('common.profilePhoto_updated'))
            } catch (e) {
                console.error('uploadTask avatar error', e)
                vm.toast(vm.$t('common.profilePhoto_error'), 'error')
            } finally {
                vm.loading = false
            }
        },
        async cropCenterSquareImage(blob) {
            return new Promise((resolve, reject) => {
                const img = new Image()
                const url = URL.createObjectURL(blob)
                img.onload = () => {
                    const size = Math.min(img.width, img.height)
                    const x = (img.width - size) / 2
                    const y = (img.height - size) / 2
                    const target = Math.min(size, 512) // cap del avatar (se muestra a ~150px)

                    const canvas = document.createElement('canvas')
                    canvas.width = target
                    canvas.height = target
                    const ctx = canvas.getContext('2d')
                    ctx.drawImage(img, x, y, size, size, 0, 0, target, target)

                    canvas.toBlob((croppedBlob) => {
                        URL.revokeObjectURL(url)
                        if (croppedBlob) resolve(croppedBlob)
                        else reject(new Error('crop failed'))
                    }, 'image/jpeg', 0.85)
                }
                img.onerror = (e) => {
                    URL.revokeObjectURL(url)
                    reject(e)
                }
                img.src = url
            })
        }

    },

}
</script>

<style scoped>
.image-tip {
    font-size: 12px;
    color: var(--v-txtMuted-base);
    word-break: break-word;
}

.upload-actions {
    display: flex;
    gap: 12px;
}

.upload-btn {
    flex: 1;
    height: 88px !important;
    flex-direction: column;
    border: 1px solid var(--v-outline-base) !important;
    background: var(--v-field-base) !important;
    border-radius: 10px !important;
    color: var(--v-txtPrimary-base) !important;
    font-weight: 600;
}

.upload-btn >>> .v-btn__content {
    flex-direction: column;
    gap: 6px;
}

.upload-btn >>> .v-icon {
    margin: 0 !important;
}
</style>
